import {Component, DestroyRef, inject, Input, OnInit} from '@angular/core';
import {TimeOffStatus} from "@services";
import EnumUtils from "../../../shared/enum-utils";
import {FilterConfig, GridPageComponent} from "../../common/grid-page.component";
import {ActivatedRoute, Router} from "@angular/router";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";

@Component({
    selector: 'app-time-off',
    imports: [],
    template: ''
})
export abstract class TimeOffRequestsComponent<T extends { status?: TimeOffStatus; }> extends GridPageComponent<T> implements OnInit {
    protected route = inject(ActivatedRoute);
    protected router = inject(Router);
    protected destroyRef = inject(DestroyRef);

    @Input() employeeId: string | null = null;
    @Input() offset: number = 156;

    statusOptions = EnumUtils.getEnumOptions(TimeOffStatus);
    protected abstract tabName: string;
    abstract dataSource: any;

    ngOnInit() {
        this.route.params.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(async params => {
            if (params['tab'] === this.tabName && params['requestId']) {
                this.selectedRow = await this.dataSource.byKey(params['requestId']);
                if (this.selectedRow) {
                    this.isPopupOpened = true;
                } else {
                    await this.router.navigate(['/time-off', this.tabName]);
                }
            }
        });
    }

    isEditVisible = (e: { row: { data: T } }) => {
        return e.row.data.status === TimeOffStatus.Pending;
    }

    isViewVisible = (e: { row: { data: T } }) => {
        return e.row.data.status !== TimeOffStatus.Pending;
    }

    protected getBadgeClass(status: TimeOffStatus): string {
        switch (status) {
            case TimeOffStatus.Approved:
                return 'bg-success-subtle text-success';
            case TimeOffStatus.Declined:
                return 'bg-danger-subtle text-danger';
            case TimeOffStatus.Withdrawn:
                return 'bg-warning-subtle text-warning';
            case TimeOffStatus.Pending:
            default:
                return 'bg-info-subtle text-info';
        }
    }

    async onStatusChange(status: TimeOffStatus) {
        await this.dataGrid.instance.refresh();
    }

    protected override filterConfig: FilterConfig[] = [
        {field: 'employee.name', op: 'contains'},
        {field: 'submittedDate', op: '>='},
        {field: 'status', op: '='},
        {field: 'number', op: 'contains'}
    ];
}
